/**
 * @generated SignedSource<<52628584fa6005a05c233ea8265d3fe3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeactivatedQuotes_deliveryOptions$data = ReadonlyArray<{
  readonly serviceId: string | null;
  readonly " $fragmentType": "DeactivatedQuotes_deliveryOptions";
}>;
export type DeactivatedQuotes_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: DeactivatedQuotes_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeactivatedQuotes_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DeactivatedQuotes_deliveryOptions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "47f30dfe5c4a934c3d8779648b9c5b93";

export default node;
